import React from "react";
import { Badge, Row, Col, Card } from "react-bootstrap";

const SCORE_STATUS_VARIANT = { NOT_APPLICABLE: "secondary", PENDING: "secondary", PARTIALLY_SCORED: "warning", CALCULATED: "info", FINALIZED: "success" };
const REVIEW_STATUS_VARIANT = { NOT_REQUIRED: "secondary", PENDING_REVIEW: "warning", PENDING_APPROVAL: "warning", APPROVED: "success", REJECTED: "danger", CHANGES_REQUESTED: "danger" };

// Phase 3C, §27/§30. Pure display component — every number here comes
// straight from GET /api/form-submissions/:id/result; nothing is
// recalculated in the browser. `result` is that endpoint's response body.
export default function FormScoreSummary({ result }) {
  if (!result) return null;

  if (!result.available) {
    return (
      <Card className="mb-3">
        <Card.Body className="text-muted small">
          Your result is not available yet
          {result.score_status === "PARTIALLY_SCORED" ? " — scoring is still in progress." : "."}
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-3">
      <Card.Body>
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
          <strong>Result</strong>
          <span>
            <Badge bg={result.is_final ? "success" : "secondary"} className="me-1">{result.is_final ? "Final" : "Provisional"}</Badge>
            <Badge bg={SCORE_STATUS_VARIANT[result.score_status] || "secondary"} className="me-1">{result.score_status}</Badge>
            <Badge bg={REVIEW_STATUS_VARIANT[result.review_status] || "secondary"}>{result.review_status}</Badge>
          </span>
        </div>
        <Row className="g-3 text-center">
          <Col xs={6} md={3}>
            <div className="small text-muted">Score</div>
            <div className="h5 mb-0">{result.obtained_score != null ? result.obtained_score : "—"} / {result.maximum_score != null ? result.maximum_score : "—"}</div>
          </Col>
          <Col xs={6} md={3}>
            <div className="small text-muted">Percentage</div>
            <div className="h5 mb-0">{result.percentage != null ? `${result.percentage}%` : "—"}</div>
          </Col>
          <Col xs={6} md={3}>
            <div className="small text-muted">Result</div>
            <div className="h5 mb-0">{result.result_label || result.result_code || "—"}</div>
          </Col>
          <Col xs={6} md={3}>
            <div className="small text-muted">Grade / Band</div>
            <div className="h5 mb-0">{result.grade || result.performance_band || "—"}</div>
          </Col>
        </Row>
        <div className="small text-muted mt-2">
          Revision {result.submission_revision}
          {result.scored_at && <> · Scored: {new Date(result.scored_at).toLocaleString()}</>}
          {result.finalized_at && <> · Finalized: {new Date(result.finalized_at).toLocaleString()}</>}
        </div>
      </Card.Body>
    </Card>
  );
}
